var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"px-2"},[_c('div',{staticClass:"project-list-type-container",style:({
        'background-color': _vm.projectListTypeColor,
        'border': _vm.projectListTypeBorder,
      })}),(_vm.showText)?_c('div',{class:_vm.addMarginRight ? 'project-list-type-text margin-right' : 'project-list-type-text'},[_vm._v(" "+_vm._s(_vm.projectListTypeText)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }